'use client'

import { Enum_Article_Category } from '@/gql/generated/graphql'
import React from 'react'

type EmbedUrlDisplayProps = {
  url: string
  title: string
  category?: Enum_Article_Category | null
}

/**
 * Transforms video URLs to their embeddable format.
 * Converts YouTube and Vimeo URLs to their respective embed endpoints.
 */
const transformToEmbedUrl = (url: string): string => {
  // Handle YouTube URLs
  const youtubeRegex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/
  const youtubeMatch = url.match(youtubeRegex)

  if (youtubeMatch) {
    const videoId = youtubeMatch[1]
    return `https://www.youtube.com/embed/${videoId}`
  }

  // Handle Vimeo URLs
  const vimeoRegex = /vimeo\.com\/(?:.*\/)?(\d+)/
  const vimeoMatch = url.match(vimeoRegex)

  if (vimeoMatch) {
    const videoId = vimeoMatch[1]
    return `https://player.vimeo.com/video/${videoId}`
  }

  // Return original URL if no transformation needed
  return url
}

export const EmbedUrlDisplay = ({ url, title, category }: EmbedUrlDisplayProps): React.ReactElement => {
  const embedUrl = transformToEmbedUrl(url)

  return (
    <div>
      {category === Enum_Article_Category.Video ? (
        <iframe
          className="my-lg"
          style={{ width: '100%', height: 'auto', aspectRatio: 1.777 }}
          src={embedUrl}
          title={title}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        />
      ) : (
        <div className="h-[30vh]">
          <iframe className="h-full w-full" src={embedUrl} title={title} />
        </div>
      )}
    </div>
  )
}
